import React, { useState } from "react";
import { useIntl } from "react-intl";

import {
  Container,
  CustomSelect,
  Content,
  InputSearch,
  NotFound,
} from "./styles";

const Select = ({
  options,
  label,
  rules,
  name,
  margin,
  isDropdownSelect = true,
  optionFilterProp = "label",
  isStaffLayout = false,
  isMultiple = false,
  getPopupContainer,
  ...props
}) => {
  const intl = useIntl();

  const [search, setSearch] = useState("");

  const handleSetValueSearch = (value) => {
    setTimeout(() => {
      setSearch(value);
    }, 300);
  };

  const resolvePopupContainer =
    getPopupContainer || ((triggerNode) => triggerNode.parentNode);

  return (
    <Container name={name} rules={rules} label={label} $margin={margin}>
      <CustomSelect
        isStaffLayout={isStaffLayout}
        mode={isMultiple ? "multiple" : undefined}
        options={options}
        $margin={margin}
        searchValue={search}
        optionFilterProp={optionFilterProp}
        $isDropdownSelect={isDropdownSelect}
        getPopupContainer={resolvePopupContainer}
        {...props}
        notFoundContent={
          <NotFound>{intl.formatMessage({ id: "not_found" })}</NotFound>
        }
        dropdownRender={(menu) => (
          <>
            {options?.length > 0 && isDropdownSelect && (
              <Content>
                <InputSearch
                  name="search-table"
                  type="seach"
                  placeholder={intl.formatMessage({ id: "search" })}
                  onChange={({ target }) => handleSetValueSearch(target.value)}
                />
              </Content>
            )}
            {menu}
          </>
        )}
      />
    </Container>
  );
};

export default Select;
